export default "__VITE_ASSET__EPtLZh6C__"